import React from 'react';
import Select from '../select/index';
import PropTypes from 'prop-types'

class DataYear extends React.Component {

  	handleChange(event, index, values) {

  		this.props.handleClick(event, index, values);
  	}
	render() {

		return (<div style={{
		//	position: 'absolute', 
		//	left: (this.props.leftOffset + 40) + 'px', 
		//	top: '0px',
			height: '125px', 
			padding: '10px',
			padding:'10px 10px 0 10px',
		//	backgroundColor:'rgba(255, 255, 255, 0.8)', 
		//	boxShadow: 'rgba(0, 0, 0, 0.156863) 0px 3px 10px, rgba(0, 0, 0, 0.227451) 0px 3px 10px',
		}}>
			<Select
				handleClick = {this.handleChange.bind(this)}
				title = 'Vēsturiskie dati'
				entries = {this.props.entries}
				selected = {[this.props.selected]}
				label = ''
			/>
	    </div>);
	}
}

DataYear.propTypes = {
  handleClick: PropTypes.func,
  entries: PropTypes.array,
  selected: PropTypes.string,
  leftOffset: PropTypes.number
};

export default DataYear




// WEBPACK FOOTER //
// ./C:/Users/viesis/Desktop/deportacijas/src/components/datayear/index.js